import axios from "axios"; 

const AxiosService = axios.create({
    baseURL: process.env.REACT_APP_URL_API,
    timeout: 8000,
    headers: {
        "Content-Type" : "application/json",
        "Accept" : "application/json"
    }
  });

export default AxiosService;